export default "__VITE_PUBLIC_ASSET__16bbab69__"